export const dataTablePreset = {
  root: {
    class: ' rounded-xl',
  },
  header: {
    class: '!rounded-xl',
  },
  wrapper: {
    class: '!rounded-tl-[12px] !rounded-tr-[12px]',
  },
  thead: {
    class: 'dark:!bg-[#101828] dark:text-gray-400',
  },
  headerCheckbox: {
    root: { class: '!border !bg-yellow-500' },
  },
  bodyCheckbox: {
    root: { class: '!border !bg-yellow-500' },
  },
  tablecontainer: 'border rounded-xl dark:border-gray-800',
  bodyRow: ({ context, props }: any) => ({
    class: [
      'h-[52px]',

      // Color
      'dark:text-white/80',
      { 'bg-primary-50 text-primary-700 dark:!bg-surface-800': context.selected },
      { 'dark:!bg-surface-900': !context.selected },

      // State
      { 'focus:!ring-0 dark:focus:!ring-0': context.selectable },
      {
        'focus:outline-none focus:outline-offset-0 focus:ring focus:ring-primary-400/50 ring-0 dark:focus:ring-0':
          context.selectable,
      },
    ],
  }),
  table: 'text-[15px]',
  column: {
    bodycell: ({ props, context, state, parent }: any) => ({
      class: [
        'text-[14px] font-medium text-gray-600 dark:text-gray-300',

        'border-0 border-b border-solid dark:!border-gray-800',
        'border-surface-200 dark:border-surface-700',
      ],
    }),
    pcheadercheckbox: {
      box: ({ props, context }: any) => ({
        class: [
          // Size
          '!w-5',
          '!h-5',
          // Shape
          'rounded-md',
          'border-2',

          // Colors
          {
            'border-surface-200 bg-surface-0 dark:border-gray-700 dark:bg-surface-900': !context.checked,
            'border-blue-600 bg-gray-200 dark:border-blue-600 dark:bg-gray-600': context.checked,
          },

          // States
          {
            'peer-hover:border-blue-700 dark:peer-hover:border-blue-600': !props.disabled && !context.checked,
            'peer-hover:border-blue-700 peer-hover:bg-gray-300 dark:peer-hover:bg-gray-500 peer-hover:border-blue-700 dark:peer-hover:border-blue-600':
              !props.disabled && context.checked,
            'peer-focus-visible:border-primary-500 dark:peer-focus-visible:border-primary-400 peer-focus-visible:ring-2 peer-focus-visible:ring-primary-400/20 dark:peer-focus-visible:ring-primary-300/20':
              !props.disabled,
            'cursor-default opacity-60': props.disabled,
          },

          // Transitions
          'transition-colors',
          'duration-200',
        ],
      }),
    },
    pcRowCheckbox: {
      box: ({ props, context }: any) => ({
        class: [
          // Size
          '!w-5',
          '!h-5',

          // Shape
          'rounded-md',
          'border-2',

          // Colors
          {
            'border-surface-200 bg-surface-0 dark:border-gray-700 dark:bg-surface-900': !context.checked,
            'border-blue-600 bg-gray-200 dark:border-blue-600 dark:bg-gray-600': context.checked,
          },

          // States
          {
            'peer-hover:border-blue-700 dark:peer-hover:border-blue-600': !props.disabled && !context.checked,
            'peer-hover:border-blue-700 peer-hover:bg-gray-300 dark:peer-hover:bg-gray-500 peer-hover:border-blue-700 dark:peer-hover:border-blue-600':
              !props.disabled && context.checked,
            'peer-focus-visible:border-primary-500 dark:peer-focus-visible:border-primary-400 peer-focus-visible:ring-2 peer-focus-visible:ring-primary-400/20 dark:peer-focus-visible:ring-primary-300/20':
              !props.disabled,
            'cursor-default opacity-60': props.disabled,
          },

          // Transitions
          'transition-colors',
          'duration-200',
        ],
      }),
    },
    // filtermenubutton: {
    //   class: '!h-6'
    // },

    headercell: ({ context, props }: any) => ({
      class: [
        'font-medium !text-[12px]',

        // Position
        { 'sticky z-20 border-b': props.frozen || props.frozen === '' },

        { relative: context.resizable },

        'dark:!bg-[#101828] dark:text-[#98A2B3]',

        // Alignment
        'text-left',

        // Shape
        { 'first:border-l border-y border-r': context?.showGridlines },
        'border-0 border-b border-solid dark:!border-gray-800',

        '!border-r-none',

        // Spacing
        context?.size === 'small' ? 'px-2 !pt-0 !pb-[1px] !min-h-[44px] !h-[44px]' : context?.size === 'large' ? 'p-5' : 'p-4',

        // Color
        (props.sortable === '' || props.sortable) && context.sorted
          ? 'bg-primary-50 text-primary-700'
          : 'bg-surface-50 text-surface-700',
        (props.sortable === '' || props.sortable) && context.sorted
          ? 'dark:text-white dark:bg-gray-900'
          : 'dark:text-white/80 dark:bg-gray-900',
        'border-surface-200 dark:border-surface-700 ',

        // States
        {
          'hover:bg-surface-100 dark:hover:bg-surface-400/30': (props.sortable === '' || props.sortable) && !context?.sorted,
        },
        'focus-visible:outline-none focus-visible:outline-offset-0 focus-visible:ring focus-visible:ring-inset focus-visible:ring-primary-400/50 dark:focus-visible:ring-primary-300/50',

        // Transition
        { 'transition duration-200': props.sortable === '' || props.sortable },

        // Misc
        { 'cursor-pointer': props.sortable === '' || props.sortable },
        {
          'overflow-hidden space-nowrap border-y bg-clip-padding': context.resizable, // Resizable
        },
      ],
    }),
    headercontent: {
      class: 'whitespace-nowrap overflow-hidden overflow-ellipsis text-[12px] dark:text-gray-400',
    },
    rowRadiobutton: {
      root: {
        class: [
          'relative',

          // Flexbox & Alignment
          'inline-flex',
          'align-bottom',

          // Size
          'w-[20px] h-[20px]',

          // Misc
          'cursor-pointer',
          'select-none',
        ],
      },
      box: ({ props }: any) => ({
        class: [
          // Flexbox
          'flex justify-center items-center',

          // Size
          'w-[20px] h-[20px]',

          // Shape
          'border-2',
          'rounded-full',

          // Transition
          'transition duration-200 ease-in-out',

          // Colors
          {
            'text-surface-700 dark:text-white/80': !props.modelValue,
            'bg-surface-0 dark:bg-surface-900': !props.modelValue,
            'border-surface-300 dark:border-surface-700': !props.modelValue,
            'border-primary-500 dark:border-primary-400': props.modelValue,
            'bg-primary-500 dark:bg-primary-400': props.modelValue,
          },

          // States
          {
            'peer-hover:border-primary-500 dark:peer-hover:border-primary-400': !props.disabled,
            'peer-hover:border-primary-600 dark:peer-hover:border-primary-300 peer-hover:bg-primary-600 dark:peer-hover:bg-primary-300':
              !props.disabled && props.modelValue,
            'peer-focus-visible:border-primary-500 dark:peer-focus-visible:border-primary-400 peer-focus-visible:ring-2 peer-focus-visible:ring-primary-400/20 dark:peer-focus-visible:ring-primary-300/20':
              !props.disabled,
            'opacity-60 cursor-default': props.disabled,
          },
        ],
      }),
    },
    filterbuttonbar: {
      class: ['!py-0 hidden'],
    },
    filterconstraint: {
      class: '!border-b-0',
    },
  },
};
